/**
 * Brand Language API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'

const i18nApi = {
    // 전체 브랜드(get total brand list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-brand-all
    guestBrands(params) {
        return httpService.get(`/guest/brands`)
    },

    // 단일 브랜드(get one brand information)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-brand-single
    guestBrand(params) {
        return httpService.get(`/guest/${params.brandCode}/brand`)
    },

    // 언어팩(get brand language pack information)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-i18n-language-pack-fetch
    guestLanguagePack(params) {
        return httpService.get(`/guest/${params.brandCode}/i18n/language/pack`)
    },

    // 기본 언어팩(get defalult brand language pack information)
    // https://clpapi.tinkeredu.co.kr/static/docs/index.html#resources-i18n-language-pack-default-fetch
    guestLanguageDefault(params) {
        return httpService.get(`/guest/${params.brandCode}/i18n/language/default`)
    },

    // 국가 코드(Country code)
    // http://13.230.87.17:8080/static/docs/guest.html#resources-guest-i18n-country
    guestCountryList(params) {
        return httpService.get(`/guest/${params.brandCode}/i18n/country/list`)
    },
    //https://dev.clp.kr/gck/api/static/docs/account.html#resources-account-change-options
    callPushNotificationApi(params) {
        return httpService.put(`/membership/member/options`, params)
    },

}

// export const 
export default i18nApi